import { Url } from '../../utils/codecUtils';
import { hookInterfaceSchema } from '../models';
import { createHookInterfacePayloadSchema } from './create.schema';

export type CreateHookInterfacePayload = {
  hook: Url;
  name: string;
  description: string;
  payload: Record<string, unknown>;
  metadata: Record<string, unknown>;
  type: string;
};

export const create = (payload: CreateHookInterfacePayload) => {
  return {
    endpoint: `/hook_interfaces`,
    method: 'POST',
    payload,
    responseSchema: hookInterfaceSchema,
    payloadSchema: createHookInterfacePayloadSchema,
  } as const;
};
